<template>
    <DefaultLayout :title="__('admin::general.edit_model', {'model': modelNameSingular.toLowerCase() })">

        <template #title>
            <InertiaLink :href="indexRoute">{{ modelNamePlural }}</InertiaLink>
            <ChevronRightIcon class="w-6 h-6 inline align-text-top text-gray-300" />
            {{ name}}
        </template>

        <template #default>

            <div class="py-6">
                <div class="mx-auto px-4 sm:px-6 md:px-8">

                    <slot name="tabs" />

                    <Panel>

                        <form @submit.prevent="submit">

                            <slot></slot>

                            <Button :loading="form.processing" class="mt-2">
                                {{ __('admin::general.update_model', {'model': modelNameSingular.toLowerCase() }) }}
                            </Button>

                        </form>

                    </Panel>

                </div>
            </div>

        </template>

    </DefaultLayout>

</template>

<script>
import { ChevronRightIcon } from '@heroicons/vue/outline'
import DefaultLayout from "@/Layouts/DefaultLayout";
import Panel from "@/Components/Panel";
import Button from "@/Components/Button";

export default {
    components: {
        Button,
        Panel,
        DefaultLayout,
        ChevronRightIcon,
    },
    props: {
        indexRoute: String,
        editRoute: String,
        updateRoute: String,
        modelNameSingular: String,
        modelNamePlural: String,
        form: Object,
        name: String,
    },
    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    _method: 'patch',
                }))
                .post(this.updateRoute);
        }
    },
}
</script>
